<style>
</style>

<template>
   <AppLayout class="resources-list-page-template" >
      <Row type="flex" justify="center">
         <Col :span="24">
            <ProfileInfoFieldsOthers></ProfileInfoFieldsOthers>
         </Col>
      </Row>
   </AppLayout>
</template>

<script>
import ProfileInfoFieldsOthers from "@/components/ProfileInfoFieldsOthers";

export default {
  name: "ProfileInfoOthers",
  components: {
    ProfileInfoFieldsOthers
  },
  computed: {
    profileFields() {
      return this.$store.state.user.userFields;
    },
    profileInfo() {
      return this.$store.state.user.info;
    },
  },
  mounted(){
    this.displayUserFields()
  },
  methods: {
    displayUserFields() {
      let indexes = []
      switch (this.profileInfo.other.status){
        case 'Family Member':
          for(let i = 0; i<this.profileFields.length; i++){
            if( this.profileFields[i].group_slug == 'agency_info' ||
              this.profileFields[i].group_slug == 'ngo_info' ||
              this.profileFields[i].group_slug == 'overseas_info' ||
              this.profileFields[i].group_slug == 'seaman_info' ){
                indexes.push(i);
              }
          }
          this.$store.commit('user/removeUserField', indexes)
        break;
        case 'NGO':1
          for(let i = 0; i<this.profileFields.length; i++){
            if( this.profileFields[i].group_slug == 'agency_info' ||
              this.profileFields[i].group_slug == 'overseas_info' ||
              this.profileFields[i].group_slug == 'seaman_info' ){
                indexes.push(i);
              }
          }
          this.$store.commit('user/removeUserField', indexes)
        break;
        case 'OWWA':
        case 'POEA':
        case 'DOLE':
        case 'DFA':1
          for(let i = 0; i<this.profileFields.length; i++){
            if( this.profileFields[i].group_slug == 'seaman_info' ||
              this.profileFields[i].group_slug == 'ngo_info' ){
                indexes.push(i);
              }
          }
          this.$store.commit('user/removeUserField', indexes)
        break;
        default:1
          for(let i = 0; i<this.profileFields.length; i++){
            if( this.profileFields[i].group_slug == 'agency_info' ||
              this.profileFields[i].group_slug == 'overseas_info' ||
              this.profileFields[i].group_slug == 'ngo_info' ){
                indexes.push(i);
              }
          }
          this.$store.commit('user/removeUserField', indexes)
        break;
      }
    }
  }
};
</script>
